import React, { useEffect, useState } from 'react';

const Preloader = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isAnimating, setIsAnimating] = useState(true);

  const logoUrl = "https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/bdhzg2gi_Rosepod%20logo%20white%20color.png";

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAnimating(false);
      setTimeout(() => {
        setIsVisible(false);
        onComplete?.();
      }, 500);
    }, 2500);

    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-[#04101C] transition-opacity duration-500 ${
        isAnimating ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="flex flex-col items-center gap-8">
        {/* Logo */}
        <div className="relative">
          <img 
            src={logoUrl} 
            alt="Rosepod" 
            className="h-16 md:h-20 w-auto"
          />
        </div>

        {/* Waveform Animation */}
        <div className="flex items-end gap-1 h-12">
          {[...Array(12)].map((_, i) => (
            <div
              key={i}
              className="w-1.5 rounded-full bg-gradient-to-t from-[#00C4CC] via-[#00E08F] to-[#FFF7AE]"
              style={{
                animation: `waveform 1s ease-in-out infinite`,
                animationDelay: `${i * 0.08}s`,
                height: '20%'
              }}
            />
          ))}
        </div>

        {/* Loading Text */}
        <p className="text-[#00E08F] text-sm tracking-widest uppercase animate-pulse">
          Loading your sound...
        </p>
      </div>

      <style>{`
        @keyframes waveform {
          0%, 100% {
            height: 20%;
          }
          50% {
            height: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default Preloader;
